import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { IcpInfo } from "../../schema/icp";

import { IcpHighlight } from "./ChatPrimitives";

/**
 * Renders the company part of the ICP sentence: "at <industries> <size>".
 * The size acts as the head noun ("at Fintech Startup"); when it is missing,
 * the generic "companies" takes its place ("at Fintech companies").
 */
const IcpCompanyPhrase: FunctionComponent<{ industries: string[]; size: string | null }> = ({
	industries,
	size,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`onboarding.chat.${key}`);

	if (industries.length === 0 && !size) {
		return null;
	}

	return (
		<>
			{" "}
			{ts("at")}{" "}
			{industries.length > 0 && (
				<>
					<IcpHighlight>{industries.join(", ")}</IcpHighlight>{" "}
				</>
			)}
			{size ? <IcpHighlight>{size}</IcpHighlight> : ts("companies")}
			{industries.length === 0 && size && <> {ts("companies")}</>}
		</>
	);
};

/**
 * Renders the ICP as a highlighted sentence fragment:
 * "<personas> at <industries> <size> in <location>".
 * Segments without data are skipped.
 */
export const IcpSummaryText: FunctionComponent<{ icp: IcpInfo }> = ({ icp }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`onboarding.chat.${key}`);

	return (
		<>
			<IcpHighlight>{icp.personas.join(", ")}</IcpHighlight>
			<IcpCompanyPhrase industries={icp.industries} size={icp.size} />
			{icp.location && (
				<>
					{" "}
					{ts("in")} <IcpHighlight>{icp.location}</IcpHighlight>
				</>
			)}
		</>
	);
};
